/**
 * ProgressBar
 *
 * Fixed top progress indicator for the multi-step survey; hides when flagged.
 */
import React, { useEffect } from 'react';

export function ProgressBar({ 
  currentStepIndex, 
  totalSteps, 
  theme, 
  themes,
  customTheme,
  getTextStyle,
  hidden = false
}) {
  // Log when component mounts or hidden changes
  useEffect(() => {
    if (hidden) {
      console.log('ProgressBar: Hidden due to surveyFull flag');
    }
  }, [hidden]);
  
  // If hidden is true, don't render the progress bar
  if (hidden === true) {
    return null;
  }
  
  return (
    <div className="fixed inset-x-0 top-0">
      <div className={`h-1 ${
        theme 
          ? theme === 'custom' ? 'bg-white/10' : 'bg-white/10' 
          : 'bg-gray-200 dark:bg-gray-800'
      }`}>
        <div
          className={`h-1 ${
            theme 
              ? theme === 'custom' ? 'bg-white/20' : 'bg-white/20' 
              : 'bg-primary-600 dark:bg-primary-400'
          } transition-all duration-500`}
          style={{ 
            width: `${((currentStepIndex + 1) / totalSteps) * 100}%`,
            ...((theme === 'custom' && getTextStyle) ? { opacity: '0.2' } : {})
          }}
        />
      </div>
    </div>
  );
}